import GenericRequest, { METHOD_POST } from '../../../webservices/GenericRequest';
import { ApiEndpoints } from '../../../webservices/endpoint';

export class ResourceOutsourceSearchTask extends GenericRequest {

    _request; // ResourceOutsourceSearchRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.COMPANIES_BASIC);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/predefined-fields/resource-outsource/ResourceOutsourceSearchTask.js